import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const getEligibilityPlans = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    // '/api/method/technoerp.services.get_eligibility_plans'
    '/api/resource/Insurance Payor Eligibility Plan?fields=["insurance_plan_name","is_active","insurance_payor","price_list","name"]'
  );
  return data;
});

export const addEligibilityPlan = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    // '/api/method/technoerp.services.create_eligibility_plan',
    '/api/resource/Insurance Payor Eligibility Plan',
    body
  );
  return data;
});
export const updateEligibilityPlan = catchAsync(async ({ body, id }) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Insurance Payor Eligibility Plan/${id}`,
    body
  );
  return data;
});

export const deleteEligibilityPlan = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Insurance Payor Eligibility Plan/${record}`
    // `/api/method/technoerp.services.delete_record?record=${record}&document=Insurance Payor Eligibility Plan`
  );
  return data;
});
export const getEligibilityPlanById = catchAsync(async (record) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Insurance Payor Eligibility Plan/${record}`
  );
  return data;
});
export const getInsurancePayors = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_insurance_payors'
  );
  return data;
});
export const getSellingPriceList = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_selling_price_list'
  );
  return data;
});
